import {toDay} from "@/libs/helper";
import {ApexOptions} from "apexcharts";
import dynamic from "next/dynamic";
import {useEffect, useState} from "react";
const Chart = dynamic(() => import("react-apexcharts"), {ssr: false});
const itemsPerPage = 7; // Number of items to show per page
interface ChartSeries {
  name: string;
  data: number[];
}
export const DistanceTrendsChart: React.FC<any> = ({statistics}) => {
  const [chartPage, setChartPage] = useState(0);
  const [chartTotalPages, setChartTotalPages] = useState(0);

  const [trendsChartOptions, setTrendsChartOptions] = useState<{
    options: ApexOptions;
    series: ChartSeries[];
  }>({
    options: {},
    series: []
  });
  const safeGet = (arr: any[] = [], key: string): number[] => {
    return arr.map(item => {
      const value = item?.[key];
      //toKilometers(value)
      return typeof value === "number" ? value : 0;
    });
  };

  useEffect(() => {
    const trends = statistics?.trends || [];
    if (!Array.isArray(trends) || trends.length === 0) return;
    if (trends.length > 0) {
      const categories = trends.map((item: any, k: number) => toDay(item.time)); // Ensure 'day' is a key like "01", "02"
      const totalPages = Math.ceil(categories.length / itemsPerPage);
      setChartTotalPages(totalPages);

      const start = chartPage * itemsPerPage;
      const end = start + itemsPerPage;

      if (start >= trends.length) return;

      const paginatedCategories = categories.slice(start, end);
      const paginatedTrends = trends.slice(start, end);

      const scheduled = safeGet(paginatedTrends, "scheduled");
      const unScheduled = safeGet(paginatedTrends, "unScheduled");
      if (
        paginatedCategories.length === 0 ||
        (scheduled.length === 0 && unScheduled.length === 0)
      )
        return;

      setTrendsChartOptions({
        options: {
          chart: {
            type: "bar",
            height: 120,
            stacked: true,
            toolbar: {show: false},
            zoom: {
              enabled: true,
              type: "xy",
              autoScaleYaxis: true
            }
            //background: isDarkMode ? "#000000" : "#ffffff"
          },
          plotOptions: {
            bar: {
              horizontal: false,
              borderRadius: 3,
              barHeight: "65%"
            }
          },
          xaxis: {
            categories: paginatedCategories,
            labels: {
              show: true,
              style: {
                fontSize: "10px",
                colors: "#64748B"
              }
            }
          },
          yaxis: {
            labels: {
              formatter: (val: number) => `${val} km`,
              style: {
                colors: "#64748B"
              }
            }
          },
          dataLabels: {enabled: false},
          legend: {
            position: "top",
            horizontalAlign: "right",
            show: false
          },
          grid: {
            padding: {left: 0, right: 0, top: 10, bottom: 0}
            //borderColor: isDarkMode ? "#334155" : "#e2e8f0"
          },
          colors: ["#22c55e", "#f97316"]
        },
        series: [
          {name: "Scheduled", data: scheduled},
          {name: "UnScheduled", data: unScheduled}
        ]
      });
    }
  }, [statistics?.trends, chartPage]);

  return (
    <div className="flex w-full flex-col">
      {trendsChartOptions.series.length > 0 && (
        <Chart
          options={trendsChartOptions.options}
          series={trendsChartOptions.series}
          type="bar"
          height={120}
        />
      )}

      <div className="flex items-center justify-between">
        <button
          onClick={() => setChartPage(p => Math.max(p - 1, 0))}
          disabled={chartPage === 0}
          className="flex items-center gap-1 rounded bg-gray-200 px-2 py-1 text-sm disabled:opacity-50"
        >
          <svg
            className="h-4 w-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <line
              x1="20"
              y1="12"
              x2="4"
              y2="12"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <line
              x1="10"
              y1="6"
              x2="4"
              y2="12"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <line
              x1="10"
              y1="18"
              x2="4"
              y2="12"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
          Prev
        </button>

        <span className="text-xs text-gray-600">
          Page {chartPage + 1} of {chartTotalPages}
        </span>

        <button
          onClick={() =>
            setChartPage(p => Math.min(p + 1, chartTotalPages - 1))
          }
          disabled={chartPage >= chartTotalPages - 1}
          className="flex items-center gap-1 rounded bg-gray-200 px-2 py-1 text-sm disabled:opacity-50"
        >
          Next
          <svg
            className="h-4 w-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <line
              x1="4"
              y1="12"
              x2="20"
              y2="12"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <line
              x1="14"
              y1="6"
              x2="20"
              y2="12"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <line
              x1="14"
              y1="18"
              x2="20"
              y2="12"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};
